var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatenaGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.707,
    height: 19.706,
    viewBox: "0 0 19.707 19.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_136",
    "data-name": "\\u30D1\\u30B9 136",
    d: "M70.081,270.228a9.853,9.853,0,1,0,9.853,9.853A9.853,9.853,0,0,0,70.081,270.228Zm.746,14.989a1.338,1.338,0,0,1-1.72,0,1.138,1.138,0,0,1,.006-1.6,1.3,1.3,0,0,1,1.707,0,1.137,1.137,0,0,1,.007,1.6Zm2.275-6.535a4.847,4.847,0,0,1-.974,1.228l-.594.564a2.019,2.019,0,0,0-.637,1.254l-.029.448H68.993a4.4,4.4,0,0,1,.249-1.635,3.356,3.356,0,0,1,.912-1.2,4.657,4.657,0,0,0,.882-.96,1.506,1.506,0,0,0,.22-.782q0-1.24-1.143-1.24a1.158,1.158,0,0,0-.868.334,1.315,1.315,0,0,0-.34.921H66.781a2.821,2.821,0,0,1,.9-2.191,4.175,4.175,0,0,1,4.837-.04,2.673,2.673,0,0,1,.857,2.122A2.589,2.589,0,0,1,73.1,278.682Z",
    transform: "translate(-60.227 -270.228)",
    fill: "#c7c7c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatenaGray);
export default __webpack_public_path__ + "static/media/hatena_gray.dde1c5a74c10504f7b2404f124eda369.svg";
export { ForwardRef as ReactComponent };